var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMismatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25858_91592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38225 7.05022C7.96021 7.05022 9.2394 5.77104 9.2394 4.19308C9.2394 2.61512 7.96021 1.33594 6.38225 1.33594C4.8043 1.33594 3.52511 2.61512 3.52511 4.19308C3.52511 5.77104 4.8043 7.05022 6.38225 7.05022Z",
    fill: "#252919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38225 8.95499C9.53817 8.95499 12.0965 11.5134 12.0965 14.6693H0.667969C0.667969 11.5134 3.22634 8.95499 6.38225 8.95499Z",
    fill: "#252919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0672 6.3828C15.4391 6.01087 15.4391 5.40786 15.0672 5.03593C14.6953 4.664 14.0922 4.664 13.7203 5.03593L13.0469 5.70936L12.3734 5.03593C12.0015 4.664 11.3985 4.664 11.0266 5.03593C10.6546 5.40786 10.6546 6.01087 11.0266 6.3828L11.7 7.05623L11.0266 7.72967C10.6546 8.1016 10.6546 8.70461 11.0266 9.07654C11.3985 9.44847 12.0015 9.44847 12.3734 9.07654L13.0469 8.4031L13.7203 9.07654C14.0922 9.44847 14.6953 9.44847 15.0672 9.07654C15.4391 8.70461 15.4391 8.1016 15.0672 7.72967L14.3937 7.05623L15.0672 6.3828Z",
    fill: "#252919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25858_91592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMismatch);
export default __webpack_public_path__ + "static/media/mismatch.3c726df87d3a4103a474c21595c5537a.svg";
export { ForwardRef as ReactComponent };